import { render, staticRenderFns } from "./NotaSegura.vue?vue&type=template&id=36ad56e4"
import script from "./NotaSegura.vue?vue&type=script&lang=js"
export * from "./NotaSegura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports